import { render, staticRenderFns } from "./widget-status-vacation.vue?vue&type=template&id=8addd17a&"
import script from "./widget-status-vacation.vue?vue&type=script&lang=js&"
export * from "./widget-status-vacation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports